import { FC } from "react";
import type { CustomHeaderProps } from "ag-grid-react";
import { ResourceExplorerGridDataWithId } from "@/store/resource-explorer/utils/types/resourceExplorerDataGrid";
import { ForecastedCost, ForecastOption } from "@/services/cloudchipr.api";
import { ForecastedCostHeaderCell } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/header-cell-components/ForecastedCostHeaderCell";

interface InnerHeaderComponentParamsProps {
  forecastOption?: ForecastOption;
  forecastedCost?: ForecastedCost;
}

export const BillingExplorerWidgetForecastedCostHeaderCell: FC<
  CustomHeaderProps<ResourceExplorerGridDataWithId>
> = ({ innerHeaderComponentParams }) => {
  const { forecastOption, forecastedCost }: InnerHeaderComponentParamsProps =
    innerHeaderComponentParams ?? {};

  if (!forecastOption) {
    return null;
  }

  return (
    <ForecastedCostHeaderCell
      forecastOption={forecastOption}
      forecastedCost={forecastedCost}
      tooltipTextSx={tooltipTextSx}
      secondaryTextSx={secondaryTextSx}
    />
  );
};

const tooltipTextSx = {
  width: "100%",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
};

const secondaryTextSx = {
  color: "text.secondary",
};
